import { resolve } from "inversify-react";
import * as React from "react";
import { connect } from "react-redux";
import { Route, RouteComponentProps, Switch, withRouter } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { actions as homeActions } from "../actions/home.actions";
import { actions as navigationActions } from "../actions/main.actions";
import Activate from "../components/account/activate";
import ResetPassword from "../components/account/reset-password";
import Button from "../core/ui/button";
import Container from "../core/ui/container";
import GenericDropDown from "../core/ui/generic-dropdown";
import IconBtn from "../core/ui/icon-btn";
import PrivateRoute from "../core/ui/private-route";
import HttpService from "../services/http.service";
import IdentityService from "../services/identity.service";
import ToastService from "../services/toast.service";
import AccountPage from "./account/account-page";
import ArtDetail from "./arts/art-detail";
import ArtEdit from "./arts/art-edit";
import FooterView from "./footer/footer";
// import {Link, Route, Switch} from 'react-router-dom';
import Home from "./home/home";
import Login from "./login/login";
import MobileMenu from "./navigation/mobile-menu";
import NavView from "./navigation/nav";
import Toasts from "./toasts/toasts.container";
import WatchIntegrityWrapper from "../core/ui/watchIntegrityWrapper";
import images from "../assets/images/index";
import BlockchainService from "../services/blockchain.service";
import ArtsDataService from "./arts/arts.data.service";
import AdminPanel from "./admin_panel/admin-panel";
import { AppLocation, IApplicationState, UserInformation } from "../typings";
import ArtsPage from "./arts/arts";

enum UserType {
    ARTIST = "artist",
    COLLECTOR = "collector",
    ADMIN = "admin",
}

export type LocationChangerProps = typeof navigationActions;

type AppProps = RouteComponentProps<any> &
    typeof homeActions & {
        isAuthenticated: boolean;
        appSection: AppLocation;
        ajaxInProgress: number;
        userInfo: UserInformation;
        dateVersion: string;
        modalOpen: number;
        containerColor: string;
    };

interface IState {
    verificationOpen: boolean;
    pageAnimationClass: string;
}
class App extends React.Component<AppProps, IState> {
    @resolve(IdentityService)
    public identity: IdentityService;

    @resolve(HttpService)
    public httpService: HttpService;

    @resolve(ToastService)
    public toastService: ToastService;

    @resolve(BlockchainService)
    public blockchianService: BlockchainService;

    @resolve(ArtsDataService)
    public artDataService: ArtsDataService;

    constructor(props) {
        super(props);

        this.state = {
            verificationOpen: true,
            pageAnimationClass: "",
        };
    }

    public async componentDidMount() {
        await this.identity.authenticate();
        // this.toastService.showToast("Version", this.props.dateVersion, "success", 10000);
        this.blockchianService.check();
    }

    public getActiveClass = (location: string) => {
        if (this.props.appSection == location) {
            return "selected";
        }
        return "";
    };

    public getActiveClassProfile = (location: string[]) => {
        if (location.find((t) => t == this.props.appSection)) {
            return "active";
        }
        return "";
    };

    public renderProfileNav() {
        const { history, appSection } = this.props;

        const profileButton = (
            <Button
                key={"profileBtn"}
                className={"nav-item nav-icon not-mobile " + this.getActiveClassProfile(["account", "balance", "settings", "collection"])}
                presentation="wire"
                leftIcon="profile"
            />
        );
        const profileOptions = [
            {
                name: "Account",
                action: () => {
                    history.push("/account/balance");
                },
                section: "balance",
            },
            {
                name: "Settings",
                action: () => {
                    history.push("/account/settings");
                },
                section: "settings",
            },
            {
                name: "Log out",
                action: () => {
                    this.identity.logout();
                    history.push("/");
                },
                section: "logout",
            },
        ];

        const profileComponent = (
            <GenericDropDown
                arrow={true}
                className={"nav-item home"}
                style={{ margin: 0 }}
                closeOnOutside={true}
                key="profile"
                trigger={profileButton}
            >
                <ul className={`dropdown-options show`} key="options-app">
                    {profileOptions.map((item, index) => {
                        return (
                            <li onClick={item.action} className={`option ${this.getActiveClass(item.section)}`} key={item.name}>
                                <label>{item.name}</label>
                            </li>
                        );
                    })}
                </ul>
            </GenericDropDown>
        );

        const profileLinks =
            this.props.userInfo !== undefined && this.props.userInfo.type === UserType.ADMIN
                ? [
                      {
                          key: "collection",
                          to: ["/account/collection"],
                          child: "Collection",
                          className: "not-mobile",
                      },
                      {
                          key: "arts",
                          to: ["/arts"],
                          child: "Gallery",
                          className: "not-mobile",
                      },
                      {
                          key: "admin",
                          to: ["/admin"],
                          child: "Admin Panel",
                          className: "not-mobile",
                      },
                  ]
                : [
                      {
                          key: "collection",
                          to: ["/account/collection"],
                          child: "Collection",
                          className: "not-mobile",
                      },
                      {
                          key: "arts",
                          to: ["/arts"],
                          child: "Gallery",
                          className: "not-mobile",
                      },
                  ];

        return (
            <NavView
                backColor={this.navBackgroundColor()}
                className={this.navBackgroundColor()}
                links={profileLinks}
                history={this.props.history}
            />
        );
    }

    public renderProfileButton() {
        const { history, appSection } = this.props;

        const profileButton = (
            <Button
                key={"profileBtn"}
                className={"nav-item nav-icon not-mobile " + this.getActiveClassProfile(["account", "balance", "settings", "collection"])}
                presentation="wire"
                leftIcon="profile"
            />
        );
        const profileOptions = [
            {
                name: "Account",
                action: () => {
                    history.push("/account/balance");
                },
                section: "balance",
            },
            {
                name: "Settings",
                action: () => {
                    history.push("/account/settings");
                },
                section: "settings",
            },
            {
                name: "Log out",
                action: () => {
                    this.identity.logout();
                    history.push("/");
                },
                section: "logout",
            },
        ];

        const profileComponent = (
            <GenericDropDown
                arrow={true}
                className={"nav-item home"}
                style={{ margin: 0 }}
                closeOnOutside={true}
                key="profile"
                trigger={profileButton}
            >
                <ul className={`dropdown-options show`} key="options-app">
                    {profileOptions.map((item, index) => {
                        return (
                            <li onClick={item.action} className={`option ${this.getActiveClass(item.section)}`} key={item.name}>
                                <label>{item.name}</label>
                            </li>
                        );
                    })}
                </ul>
            </GenericDropDown>
        );

        const profileLinks = [
            {
                key: "profile",
                to: [],
                isNode: true,
                child: profileComponent,
                className: "not-mobile",
            },
        ];
        return <NavView end={true} className="profile" links={profileLinks} history={this.props.history} />;
    }

    public isShareable = () => {
        return ["home", "about_us", "news", "arts"].find((e) => e == this.props.appSection) != null;
    };

    public navBackgroundColor = () => {
        switch (this.props.containerColor) {
            case "blue":
                return "#E8F0F6";
            case "gray":
                return "#edf0f2";
            case "light":
                return "#ffffff";
            default:
                return "#ffffff";
        }
    };

    public render() {
        const { history } = this.props;

        const topLinks = [
            {
                key: "home",
                to: ["/", "home"],
                child: "HOME",
                className: "not-mobile",
            },
            {
                key: "why_us",
                to: ["/", "why_us"],
                child: "FOR ARTISTS AND COLLECTORS",
                className: "not-mobile",
            },
            {
                key: "our_vision",
                to: ["/", "our_vision"],
                child: "OUR VISION",
                isInned: true,
                className: "not-mobile",
            },
            {
                key: "our_team",
                to: ["/", "our_team"],
                child: "OUR TEAM",
                isInned: true,
                className: "not-mobile",
            },
            {
                key: "arts",
                to: ["/arts", "arts"],
                child: "GALLERY",
                className: "not-mobile",
            },
        ];

        const authLinks = [
            {
                key: "sign_in",
                to: ["/"],
                child: (
                    <a className="nav-item not-mobile" key="sign_in" onClick={() => this.props.toggleLogin(true, 0)}>
                        LOG IN
                    </a>
                ),
                isNode: true,
                className: "tight-horizontal-spacing",
            },
            {
                key: "auth_slash",
                child: "/",
                isNode: true,
                className: "tight-horizontal-spacing",
            },
            {
                key: "sign_up",
                to: ["/"],
                child: (
                    <a className="nav-item not-mobile" key="sign_up" onClick={() => this.props.toggleLogin(true, 1)}>
                        SIGN UP
                    </a>
                ),
                isNode: true,
                className: "tight-horizontal-spacing",
            },
        ];

        const url = `${this.httpService.domainUrl}${this.props.location.pathname}`;

        const sideLinks = [
            {
                key: "instagram",
                to: ["/"],
                child: (
                    <IconBtn className="not-mobile" key="instaBtn" type="instagram" url="https://www.instagram.com/encrypto_official/" />
                ),
                isNode: true,
            },
            {
                key: "twitter",
                to: ["/"],
                child: <IconBtn className="not-mobile" key="faceBtn" type="twitter" url="https://twitter.com/EncryptoArt" />,
                isNode: true,
            },
            /*{
        key: 'instagram',
        to: ['/'],
        child: <IconBtn className='not-mobile' key='insBtn' type='instagram' />,
        isNode: true
      }*/
        ];

        const firstChild = (props) => {
            const childrenArray = React.Children.toArray(props.children);
            return childrenArray[0] || null;
        };
        const redirectTo = "/account/balance";
        return (
            <div className={`${this.props.modalOpen ? "blurry-child main-wrapper" : ""}`}>
                {!this.props.isAuthenticated && (
                    <NavView links={topLinks} backColor={this.navBackgroundColor()} history={this.props.history} />
                )}
                {!this.props.isAuthenticated && <NavView end={true} links={authLinks} history={this.props.history} className="no-shadow" />}
                {this.props.isAuthenticated && this.renderProfileButton()}
                {this.props.isAuthenticated && this.renderProfileNav()}
                {/* {this.isShareable() && <NavView vertical={true} links={sideLinks} history={this.props.history}/>} */}
                {this.props.ajaxInProgress > 0 && <div className="loading"></div>}
                <Login visible={false} selectedPrompt={0} />
                <img className="home-icon" src={images.logo} onClick={() => this.props.history.push("/")} />
                {/* <MetamaskRquiredComponent /> */}
                <MobileMenu history={this.props.history} />

                <TransitionGroup className="route-container">
                    <CSSTransition classNames="page" timeout={700} unmountOnExit={false} mountOnEnter={true} key={this.props.location.key}>
                        <Switch>
                            <Route exact={true} path="/">
                                <Home />
                            </Route>
                            <Route exact={true} path="/arts">
                                <WatchIntegrityWrapper history={history} redirectTo={redirectTo}>
                                    <ArtsPage history={history} urlPreffix="art" />
                                </WatchIntegrityWrapper>
                            </Route>
                            <Route exact={true} path="/art/:id">
                                <WatchIntegrityWrapper history={history} redirectTo={redirectTo}>
                                    <ArtDetail
                                        getNext={(t) => this.props.history.push(`/art/${t.next}`)}
                                        getPrevious={(t) => this.props.history.push(`/art/${t.previous}`)}
                                        history={history}
                                    />
                                </WatchIntegrityWrapper>
                            </Route>
                            <Route exact={true} path="/collection/:id">
                                <WatchIntegrityWrapper history={history} redirectTo={redirectTo}>
                                    <ArtDetail
                                        getNext={(t) => this.props.history.push(`/collection/${t.next}`)}
                                        getPrevious={(t) => this.props.history.push(`/collection/${t.previous}`)}
                                        getNextArttoken={(t) => this.artDataService.getNeighborsInCollection(t.id)[1]}
                                        getPreviousArttoken={(t) => this.artDataService.getNeighborsInCollection(t.id)[0]}
                                        history={history}
                                    />
                                </WatchIntegrityWrapper>
                            </Route>
                            <PrivateRoute exact={true} path="/art/edit/:id">
                                <WatchIntegrityWrapper history={history} redirectTo={redirectTo}>
                                    <ArtEdit history={history} />
                                </WatchIntegrityWrapper>
                            </PrivateRoute>

                            <Route exact={true} path="/activate/:uid/:key" component={Activate} />
                            <Route exact={true} path="/password/reset/confirm/:uid/:key" component={ResetPassword} />

                            <PrivateRoute exact={false} path="/account" component={AccountPage} />

                            <Route exact={true} path="/admin" component={AdminPanel}></Route>

                            <Route>
                                <Container>
                                    <div className="page-404">
                                        <h1>404 Page not found</h1>
                                        <p>We apologize for the inconvenient, we are working to improve the service.</p>
                                    </div>
                                </Container>
                            </Route>
                        </Switch>
                    </CSSTransition>
                </TransitionGroup>
                <Toasts />
                <FooterView
                    isAuthenticated={this.props.isAuthenticated}
                    onSignUp={() => this.props.toggleLogin(true, 1)}
                    onLogin={() => this.props.toggleLogin(true, 0)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownProps: any) => {
    // tslint:disable-next-line:no-console
    return {
        ...ownProps,
        name: state.name,
        isAuthenticated: state.identity.isAuthenticated,
        userInfo: state.identity.userInfo,
        appSection: state.appLocation,
        ajaxInProgress: state.ajaxCallsInProgress,
        modalOpen: state.modalOpen,
        dateVersion: state.dateVersion,
        containerColor: state.containerOnScreen.idk,
    };
};

export default withRouter(connect(mapStateToProps, { ...homeActions })(App));



// WEBPACK FOOTER //
// ./src/components/App.tsx